import { Grid, LinearProgress } from '@mui/material';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';

const AuthCallback = () => {
    const Nav = useNavigate();

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        // const userEncoded = urlParams.get('user');

        // if (userEncoded) {
        //     try {
        //        let user = JSON.parse(base64.decode(userEncoded));
               
        //     } catch (error) {
        //         console.error('Failed to decode user data:', error);
        //     }
        // }
        if (token) {
            sessionStorage.setItem('token', token);
            Nav('/dashboard/default');  
        } else {
            Nav('/');  
        }
    }, [history]);

    return (
        <Grid container>
            <Grid item>
                <LinearProgress/>
            </Grid>
        </Grid>
    )
};

export default AuthCallback;
